import { ParsedUrlParams } from "../tools/helper";

import { useQuery } from "@tanstack/react-query";

export const useUrlParam = <T extends keyof ParsedUrlParams>(
  param: T,
): ParsedUrlParams[T] | undefined => {
  const { data } = useQuery<ParsedUrlParams[T]>({
    queryKey: ["urlParams", param],
    queryFn: () => undefined,
    enabled: false,
  });
  return data;
};

export const useUrlParams = (): ParsedUrlParams => {
  const { data: cfgObjectId } = useQuery<string>({
    queryKey: ["urlParams", "cfgObjectId"],
    queryFn: () => "",
    enabled: false,
  });

  const { data: language } = useQuery<string>({
    queryKey: ["urlParams", "language"],
    queryFn: () => "",
    enabled: false,
  });

  const { data: uiCulture } = useQuery<string>({
    queryKey: ["urlParams", "uiCulture"],
    queryFn: () => "",
    enabled: false,
  });

  const { data: currencyId } = useQuery<string>({
    queryKey: ["urlParams", "currencyId"],
    queryFn: () => "",
    enabled: false,
  });

  const { data: params } = useQuery<string>({
    queryKey: ["urlParams", "params"],
    queryFn: () => "",
    enabled: false,
  });

  // [KS] its type will probably change
  const { data: context } = useQuery<{ [key: string]: unknown }>({
    queryKey: ["urlParams", "context"],
    queryFn: () => ({}),
    enabled: false,
  });

  return {
    cfgObjectId,
    language,
    uiCulture,
    currencyId,
    params,
    context,
  };
};
